import { fetch } from '@moonpig/web-core-fetch'
import { getBrowserCookies } from '@moonpig/web-core-browser-storage'
import { SESSION_ID } from './cookies'
import { getAuthUrl } from './utils'

export const getAuthToken = async ({
  authBaseUrl = getAuthUrl(),
}: {
  authBaseUrl?: string
} = {}): Promise<void> => {
  const ce = navigator.cookieEnabled
  const cookies = getBrowserCookies()

  const dedupe = cookies

  const url = `${authBaseUrl}/token?ce=${ce}`
  const req = await fetch(url, {
    dedupe,
    method: 'POST',
    credentials: 'include',
    headers: {
      'mnpg-session-id': cookies[SESSION_ID],
    },
  })
  if (!req.ok) {
    throw new Error(`Fetch auth token response ${req.statusText} ce:${ce}`)
  }
}
